import { render, staticRenderFns } from "./OwnersEdit.vue?vue&type=template&id=5dc909a9&"
import script from "./OwnersEdit.vue?vue&type=script&lang=js&"
export * from "./OwnersEdit.vue?vue&type=script&lang=js&"
import style0 from "./OwnersEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports